import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Input, OnInit } from '@angular/core';

import { GridModule, GridNoRowsComponent } from '@mds/ui';
import { GridOverrides, numberValueConversion, RowSelection } from '@mds/common';

@Component({
  selector: 'app-epd-impact-table',
  standalone: true,
  imports: [GridModule],
  templateUrl: './epd-impact-table.component.html',
  styleUrls: ['./epd-impact-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EpdImpactTableComponent implements OnInit {
  @Input() data: any;
  overrides: GridOverrides;
  private cdr = inject(ChangeDetectorRef);

  ngOnInit(): void {
    this.createGridData(this.data);
  }

  private createGridData(data) {
    const columnDefs = this.getColumns(data[0]?.stages);
    const rowData = this.getRowData(data);
    this.overrides = {
      columnDefs,
      rowData,
      defaultColDef: {
        lockPosition: true,
        lockPinned: true,
        sortable: true,
        resizable: true,
        filter: true,
        floatingFilter: false,
        width: 125
      },
      sideBar: {
        toolPanels: [
          {
            id: 'columns',
            labelDefault: 'Columns',
            labelKey: 'columns',
            iconKey: 'columns',
            toolPanel: 'agColumnsToolPanel',
            toolPanelParams: {
              suppressPivotMode: true
            }
          }
        ]
      },
      suppressRowClickSelection: true,
      rowSelection: RowSelection.SINGLE,
      headerHeight: 48,
      getRowHeight: () => 32,
      noRowsOverlayComponent: GridNoRowsComponent,
      paginationAutoPageSize: false,
      pagination: false,
      noRowsOverlayComponentParams: {
        title: 'No data to show the table',
        description: ''
      }
    };
    this.cdr.markForCheck();
  }

  getColumns(columns: any[]): any[] {
    const columnDefs: any = [
      {
        headerName: 'Nr',
        filter: '',
        pinned: 'left',
        field: 'index',
        width: 75,
        minWidth: 75
      },
      {
        headerName: 'Impact Category',
        filter: '',
        pinned: 'left',
        minWidth: 200,
        field: 'name',
        tooltipField: 'name'
      },
      {
        headerName: 'Unit',
        filter: '',
        pinned: 'left',
        field: 'unit',
        tooltipField: 'unit'
      }
    ];
    const upStream = [];
    const downStream = [];
    columns.forEach((column) => {
      if (column.code === 'a1_a3') {
        upStream.push({
          headerName: column.code.toUpperCase(),
          filter: '',
          field: column.code,
          tooltipField: column.code
        });
      } else {
        downStream.push({
          headerName: column.code.toUpperCase(),
          filter: '',
          field: column.code,
          tooltipField: column.code
        });
      }
    });
    columnDefs.push({
      headerName: 'Upstream',
      children: upStream
    });
    columnDefs.push({
      headerName: 'Downstream',
      children: downStream
    });
    return columnDefs;
  }

  getRowData(data: any): Record<string, any>[] {
    return data.map((item: any, index: number) => {
      const stages = {};
      item.stages.forEach((stage: { code: string; value: number }) => {
        stages[stage.code] = numberValueConversion(stage.value);
      });
      return {
        index: index + 1,
        ...item,
        ...stages
      };
    });
  }
}
